import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { PARTNER_UPDATE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_project = (data) => {
    return (dispatch, getState) => {

        return Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.get(`${Config.API_BASE_URL}/partner/projects/${data.projectId}`, config)
                .then(response => {
                    dispatch({
                        type: PARTNER_UPDATE,
                        payload: {
                            project: { ...response.data },
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    })
                })
                .catch(error => {
                    dispatch({
                        type: PARTNER_UPDATE,
                        payload: {
                            errors: {},
                            task: {
                                result: false
                            }
                        }
                    })
                });
        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_project;